export const title = () => ({
    display: 'block',
    width: 'calc(100% - 3rem)',

    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',

    marginBottom: '5rem',

    tabletLarge: {
        width: 'calc(100% - 7.5rem)',

        paddingRight: '3.75rem',
        paddingLeft: '3.75rem',

        marginBottom: '5rem',
    },

    desktopFullHD: {
        maxWidth: '95rem',
        margin: 'auto',

        marginBottom: '5rem',
    },
});

export const container = () => ({
    paddingTop: 0,

    tabletLarge: {
        paddingTop: 0,
    },
});
